export const SITE_TITLE = 'Daily Sales Log (DSL)';
export const LOGO_TITLE = 'Daily Sales Log ';
export const SHORT_TITLE = 'DSL';
export const PATH = 'dsl';
export const VERSION = process.env.REACT_APP_VERSION;
export const COPYRIGHT = '© Geneva Media Services LLC';

export const ENVIRONMENTS = {
  dev: {
    hostname: process.env.REACT_APP_DEV_API_HOST,
    url: process.env.REACT_APP_DEV_API_URL,
    key: process.env.REACT_APP_DEV_API_KEY
  },
  test: {
    hostname: process.env.REACT_APP_TEST_API_HOST,
    url: process.env.REACT_APP_TEST_API_URL,
    key: process.env.REACT_APP_TEST_API_KEY
  },
  stage: {
    hostname: process.env.REACT_APP_STAGE_API_HOST,
    url: process.env.REACT_APP_STAGE_API_URL,
    key: process.env.REACT_APP_STAGE_API_KEY
  },
  prod: {
    hostname: process.env.REACT_APP_PROD_API_HOST,
    url: process.env.REACT_APP_PROD_API_URL,
    key: process.env.REACT_APP_PROD_API_KEY
  }
};

export const DEBUG = false;

// UI

export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export const BREAKPOINTS = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 1250,
  xl: 1800
};

export const VARIANTS = ['primary', 'secondary', 'success', 'warning', 'danger', 'info'];

export const TIMES = {
  configurationTimerLength: 12, // in hours
  modalDuration: 2, // in seconds
  reauthWarningTime: 2, // in minutes
  sessionTimerLength: 5, // in seconds
  transitionDuration: 150, // in milliseconds
  tooltipDelay: 500 // in milliseconds
};

export const MENU_WIDTHS = {
  sm: true,
  lg: false
};

export const TABLE_ROWS = {
  default: 50,
  options: [10, 25, 50, 100]
};

export const SORT_ORDER = {
  ascending: 'A',
  descending: 'D'
};

export const MODAL_PRIORITY = {
  low: -1,
  default: 0,
  high: 2,
  override: 3
};

// DEFAULT OPTIONS

export const YEAR_LENGTH = 2;

// DATA

export const DELIVERY_METHOD = {
  email: 'E',
  text: 'T'
};

export const USER_ROLES = {
  dslAdmin: {
    key:          'DSLADM',
    label:        'Daily Sales Log Admin',
    variant:      'success'
  },
  salesManager: {
    key:          'SLSSTF',
    label:        'Sales Manager',
    variant:      'primary'
  },
  salesManagerPlus: {
    key:          'SMPLUS',
    label:        'Sales Manager Plus',
    variant:      'primary'
  },
  inventoryManager: {
    key:          'INVMGD',
    label:        'Inventory Manager (Limited Access)',
    variant:      'primary'
  },
  financeManager: {
    key:          'FINMGR',
    label:        'Finance Manager',
    variant:      'primary'
  }
};

export const PRIVILEGES = {};

export const IMV_LABELS = ['Fair', 'Good', 'Great', 'High', 'Overpriced'];

export const PRODUCT_TYPES = ['Aftermarket Product (AM)', 'Finance Product (F&I)'];
export const NEW_USED_TYPES = ['Pre-Owned', 'New'];

// DATES

export const DATE_FORMATS = {
  date: 'MM/dd/yyyy',
  dateTime: 'MM/dd/yyyy h:mm aa',
  spotDate: 'MMMM dd yyyy, h:mm:ss',
  shortDate: 'MM/dd/yy',
  shortDateTime: 'MM/dd/yy h:mm aa',
  time: 'h:mm:ss aa'
};

// CHARTS

export const CHART_COLORS = {
  blue: '#2D5499',
  teal: '#21becb',
  cyan: '#2196f3',
  orange: '#DB6C0A',
  green: '#15AC54',
  yellow: '#DDB52A',
  red: '#D61D30',
  purple: '#673ab7',
  gray: '#6B7492'
};

// STATUS

export const VIEW_STATUSES = {
  amFinance: {
    view: 'am-finance',
    statuses: ['amfinance', 'sold']
  },
  fallout: {
    view: 'fallout',
    statuses: ['fallout']
  },
  order: {
    view: 'order',
    statuses: ['order']
  },
  sales: {
    view: 'sales',
    statuses: ['delivered', 'backout', 'carryover'],
  }
};

// FILES

export const FILE_CHUNK_SIZE = 3 * 1024 * 1024; // 3 MB per chunk

export const INVENTORY_FILE_TYPE_IDS = {
  FACTORY_INVOICE_NEW:     1,
  OTHER_NEW:               2,
  PURCHASE_INVOICE_USED:   3,
  OTHER_USED:              4,
  MSRP_STICKER_NEW:        5,
  BILL_OF_LADING_NEW:      6,
  BILL_OF_LADING_USED:     7,
  DX_DOCUMENTS_NEW:        8,
  DX_DOCUMENTS_USED:       9,
  INVENTORY_DETAIL_NEW:    10,
  INVENTORY_DETAIL_USED:   11,
  REPAIR_INVOICE_NEW:      12,
  REPAIR_INVOICE_USED:     13,
  PURCHASE_APPRAISAL_USED: 14,
  VIN_PHOTO_NEW:           15,
  VIN_PHOTO_USED:          16,
  MILEAGE_PHOTO_NEW:       17,
  MILEAGE_PHOTO_USED:      18,
  TRADE_APPRAISAL_USED:    19,
  MSRP_STICKER_USED:       20,
  TRADE_POSESSION:         21,
  TRADE_REGISTRATION:      22,
  TRADE_INSPECTION:        23,
};

export const SALES_FILE_TYPE_IDS = {
  INVOICE_DOWN_PAYMENT:                     0,
  INVOICE_RETAIL_USED:                      1,  // DEPRECATED: Use Inventory File Upload API
  EDP_RETAIL_USED:                          2,  // Detailed
  EBOS_RETAIL_USED:                         3,  // Detailed
  OTHER_RETAIL_USED:                        4,  // Detailed
  EDP_WHOLESALE_USED:                       5,  // Simplified
  OTHER_WHOLESALE_USED:                     6,  // Simplified
  EDP_WHOLESALE_NEW:                        7,  // Simplified
  OTHER_WHOLESALE_NEW:                      8,  // Simplified
  INVOICE_RETAIL_NEW:                       9,  // DEPRECATED: Use Inventory File Upload API
  EDP_RETAIL_NEW:                           10, // Detailed
  EBOS_RETAIL_NEW:                          11, // Detailed
  OTHER_RETAIL_NEW:                         12, // Detailed
  MSRP_RETAIL_NEW:                          13, // DEPRECATED: Use Inventory File Upload API
  INVOICE_WHOLESALE_NEW:                    14, // DEPRECATED: Use Inventory File Upload API
  EBOS_WHOLESALE_NEW:                       15, // Simplified
  INVOICE_WHOLESALE_USED:                   16, // DEPRECATED: Use Inventory File Upload API
  EBOS_WHOLESALE_USED:                      17, // Simplified
  ACCOUNTING_TAG_TITLE_DOCS_RETAIL_USED:    18,
  ACCOUNTING_TAG_TITLE_DOCS_RETAIL_NEW:     19,
  ACCOUNTING_TAG_TITLE_DOCS_WHOLESALE_USED: 20,
  ACCOUNTING_TAG_TITLE_DOCS_WHOLESALE_NEW:  21,
  REBATE_RETAIL_USED:                       22, // Detailed
  REBATE_RETAIL_NEW:                        23, // Detailed
  REBATE_WHOLESALE_USED:                    24, // Simplified
  REBATE_WHOLESALE_NEW:                     25, // Simplified
  AMFI_PRODUCT_RETAIL_USED:                 26, // Detailed
  AMFI_PRODUCT_RETAIL_NEW:                  27,  // Detailed,
  SPOT_INSTRUCTION_RETAIL_USED:             28,
  SPOT_INSTRUCTION_RETAIL_NEW:              29,
  SPOT_INSTRUCTION_WHOLESALE_USED:          30,
  SPOT_INSTRUCTION_WHOLESALE_NEW:           31,
};

export const NO_VIEW_FILE_ACTIVITIES = [
  "buyers guide",
  'buyers order',
  'cleanup',
  'clean up',
  'detail',
  'gross recap',
  'inspection',
  'permission to drive',
  'twg cancellation',
  'vehicle info'
];
